module.exports = __webpack_public_path__ + "img/logout-icon.9bcd78f9.svg";